import { PlotDataProvider } from "../components/plot/PlotDataProvider";

export default function getMonthlyPlotData(dataResults) {
  const plotDataProvider = new PlotDataProvider();
  return plotDataProvider.getMonthlyPlotDataInGroups(dataResults);
}
